var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[_c('v-table',{attrs:{"url":"/api/v1/customerProfile","filter":[
      {
        name: 'AffiliateUser',
        value: _vm.id
      }
    ],"attributes":[
      {
        attribute: 'name',
        name: 'Name',
        type: 'ProfileCell'
      },
      {
        attribute: 'created_at',
        name: 'Registrierung',
        type: 'DateTimeCell'
      }
    ]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }